import type { FormSchema } from '@cli-types/core-engine/schema.js'
import { collectInvalidFormColumnReferenceErrors } from './collect-invalid-form-column-reference-errors.js'
import { collectInvalidFormColumnTypeErrors } from './collect-invalid-form-column-type-errors.js'
import { collectInvalidFormFieldTypeErrors } from './collect-invalid-form-field-type-errors.js'
import { collectInvalidHeightErrors } from './collect-invalid-height-errors.js'
import { collectInvalidSlotErrors } from './collect-invalid-slot-errors.js'
import { collectMissingFormSchemaTitleErrors } from './collect-missing-form-schema-title-errors.js'

export function validateFormSchema(schema: FormSchema): string[] {
  const errors: string[] = []

  if (schema.type !== 'form') {
    errors.push('Form schema must have `type: "form"`')
  }
  if (!schema.name || typeof schema.name !== 'string') {
    errors.push('Form schema must have a valid "name" field')
  }
  if (!schema.label || typeof schema.label !== 'string') {
    errors.push('Form schema must have a valid "label" field')
  }
  if (!schema.description || typeof schema.description !== 'string') {
    errors.push('Form schema must have a valid "description" field')
  }
  if (!schema.icon || typeof schema.icon !== 'string') {
    errors.push('Form schema must have a valid "icon" field')
  }

  const hasFields = Array.isArray(schema.fields) && schema.fields.length > 0
  const hasSteps = Array.isArray(schema.steps) && schema.steps.length > 0

  if (!hasFields && !hasSteps) {
    errors.push('Form schema must have either "fields" or "steps"')
  }
  if (hasFields && hasSteps) {
    errors.push('Form schema cannot have both "fields" and "steps"')
  }

  if (hasSteps) {
    for (const step of schema.steps!) {
      if (!step.name || !step.label) {
        errors.push(`Form step is missing name or label: ${JSON.stringify(step)}`)
      }
      if (!Array.isArray(step.fields) || step.fields.length === 0) {
        errors.push(`Form step "${step.name}" must have at least one field`)
      } else {
        collectInvalidFormFieldTypeErrors(step.fields, errors)
        collectInvalidSlotErrors(step.fields, `steps.${step.name}`, errors)
        collectInvalidHeightErrors(step.fields, `steps.${step.name}`, errors)
      }
    }
  } else if (hasFields) {
    collectInvalidFormFieldTypeErrors(schema.fields || [], errors)
    collectInvalidSlotErrors(schema.fields || [], '', errors)
    collectInvalidHeightErrors(schema.fields || [], '', errors)
  }
  collectMissingFormSchemaTitleErrors(schema, errors)
  collectInvalidFormColumnTypeErrors(schema, errors)
  collectInvalidFormColumnReferenceErrors(schema, errors)

  return errors
}
